import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProyectosService } from '../../../services/proyectos.service';

@Component({
  selector: 'app-carretera-lima',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './carretera-lima.html',
  styleUrl: './carretera-lima.css'
})
export class CarreteraLimaComponent implements OnInit {
  proyectosRecomendados: any[] = [];

  constructor(private proyectosService: ProyectosService) {}

  ngOnInit() {
    this.proyectosRecomendados = this.proyectosService.getProyectosAleatorios('/proyectos/carretera-lima');
  }
}
